import { action } from 'typesafe-actions';
import { ICustomer } from '../customers/types';
import { Types, ICreditLimits } from './types';

export const loadCreditLimits = (selectedCustomerId: string) =>
  action(Types.LOAD_CREDIT_LIMITS, { selectedCustomerId });
export const loadCreditLimitsSuccess = (creditLimits: ICreditLimits) =>
  action(Types.LOAD_CREDIT_LIMITS_SUCCESS, { creditLimits });
export const loadCreditLimitsFailure = (error: unknown) =>
  action(Types.LOAD_CREDIT_LIMITS_FAILURE, { error });

export const requestRenewCreditLimits = (
  customer: ICustomer,
  renewCreditValue: number,
  files: File[]
) =>
  action(Types.REQUEST_RENEW_CREDIT_LIMITS, {
    customer,
    renewCreditValue,
    files
  });
export const requestRenewCreditLimitsSuccess = (alreadyRequested: boolean) =>
  action(Types.REQUEST_RENEW_CREDIT_LIMITS_SUCCESS, { alreadyRequested });
export const requestRenewCreditLimitsFailure = (error: unknown) =>
  action(Types.REQUEST_RENEW_CREDIT_LIMITS_FAILURE, { error });
